import React, { useState } from 'react';
import PreviewBar from '../components/PreviewBar';

const PREVIEW_HASH_KEY = 'giftbox-preview';
const PREVIEW_ERROR_KEY = 'giftbox-preview-error';
const ERROR_INVALID_PREVIEW =
  'Invalid preview URL. Defaulting to active offers only.';

export function getPreviewHash() {
  let previewHash = window.sessionStorage.getItem(PREVIEW_HASH_KEY);
  if (previewHash) return previewHash;

  const hasError = window.sessionStorage.getItem(PREVIEW_ERROR_KEY);
  if (hasError) return undefined;

  const parsedUrl = new URL(window.location.href);
  previewHash = parsedUrl.searchParams.get('giftbox_preview');
  if (previewHash) {
    window.sessionStorage.setItem(PREVIEW_HASH_KEY, previewHash);
    return previewHash;
  }

  return undefined;
}

const PreviewContext = React.createContext();

export function PreviewContextProvider({ children }) {
  const previewHash = getPreviewHash();
  const [error, setError] = useState(
    window.sessionStorage.getItem(PREVIEW_ERROR_KEY),
  );

  const onPreviewException = () => {
    window.sessionStorage.setItem(PREVIEW_ERROR_KEY, ERROR_INVALID_PREVIEW);
    window.sessionStorage.removeItem(PREVIEW_HASH_KEY);
    setError(ERROR_INVALID_PREVIEW);
  };

  return (
    <PreviewContext.Provider
      value={{
        previewHash: !error ? previewHash : undefined,
        onPreviewException,
        error,
        isPreview: !!previewHash || !!error,
      }}
    >
      <PreviewBar />
      {children}
    </PreviewContext.Provider>
  );
}

export default PreviewContext;
